import React, { useState } from "react";
import { forgotPassword } from "../../../api/api";
import { useNavigate } from "react-router-dom";
import useRecaptcha from "../../../hooks/useRecaptcha";
import styles from "./ForgotPassword.module.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { getRecaptchaToken } = useRecaptcha();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    try {
      const recaptchaToken = await getRecaptchaToken("forgot_password");
      if (!recaptchaToken) {
        setError("reCAPTCHA verification failed. Please try again.");
        return;
      }
      await forgotPassword(email, recaptchaToken);
      setMessage("A password reset link has been sent to your email.");
    } catch (error) {
      setError(
        error.response?.data?.error || "Failed to send reset link. Try again."
      );
    }
  };

  return (
      <div className={styles.wrapper}>
    <div className={styles.container}>
      <h2>Forgot Password</h2>
      {message && <p className={styles.successMessage}>{message}</p>}
      {error && <p className={styles.errorMessage}>{error}</p>}

      <form onSubmit={handleForgotPassword} className={styles.form}>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Send Reset Link</button>
      </form>

      <button
        className={styles.backButton}
        onClick={() => navigate("/login")}
      >
        Back to Login
      </button>
    </div>
    </div>
  );
};

export default ForgotPassword;
